import Vue from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import qs from 'qs'
import App from './App.vue'
import './components/EleModule/index'


Vue.use(Vant)
Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.prototype.$axios= axios;
Vue.prototype.$qs = qs;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
